export default {
  download: 'Baixar',
  forward: 'Encaminhar',
  forward_link: 'Encaminhar link',
  forward_image: 'Encaminhar imagem',
  forward_file: 'Encaminhar arquivo',
  forward_message: 'Encaminhar mensagem',
};
